import { BindingCreator } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { invoiceSharedComponentsTranslationKeys } from '../translations';

const DESCRIPTION_FIELD_NAME = 'description';
const DESCRIPTION_MAX_LENGTH = 500;

export type DescriptionFormBeanPart = {
   [DESCRIPTION_FIELD_NAME]: string;
};

type DescriptionFieldProps = {
   readonly register: BindingCreator<DescriptionFormBeanPart, typeof DESCRIPTION_FIELD_NAME>;
};

export const DescriptionField = (props: DescriptionFieldProps): JSX.Element => {
   return (
      <Textarea
         controller={props.register(DESCRIPTION_FIELD_NAME)}
         rows={4}
         maxRows={4}
         maxLength={DESCRIPTION_MAX_LENGTH}
         label={invoiceSharedComponentsTranslationKeys.description.label}
         placeholder={invoiceSharedComponentsTranslationKeys.description.placeholder}
         testId={DESCRIPTION_FIELD_NAME}
      />
   );
};
